import { FundValueBridgeData } from '../types';

export const BRIDGE_FIELDS: Array<{
  key: keyof FundValueBridgeData;
  label: string;
  isTotal?: boolean;
  isStartTotal?: boolean;
  isEndTotal?: boolean;
}> = [
  {
    key: 'startingNav',
    label: 'Fund asset value',
    isTotal: true,
    isStartTotal: true,
  },
  { key: 'paidInCapital', label: 'Paid-in capital' },
  { key: 'portfolioValueGains', label: 'Portfolio value gains' },
  { key: 'fundIncome', label: 'Fund income' },
  { key: 'portfolioValueLosses', label: 'Portfolio value losses' },
  { key: 'managementFees', label: 'Management fees' },
  { key: 'fundExpenses', label: 'Fund expenses' },
  { key: 'distributions', label: 'Distributions' },
  { key: 'carriedInterest', label: 'Carried interest' },
  {
    key: 'endingNav',
    label: 'Fund asset value',
    isTotal: true,
    isEndTotal: true,
  },
];

export const DEFAULT_Y_AXIS_STEP = 1_000_000;
export const VALUE_BAND_BELOW_NEGATIVE_RATIO = 0.45;
export const BRIDGE_FOCUSED_NAV_THRESHOLD = 10_000_000;
export const POSITIVE_Y_AXIS_STEP_COUNT = 4;
